//判断是否是数组  返回
function isArray(ary){
    if(!ary){ return false; }
    let val = typeof ary === 'object' && !isNaN(ary.length);
    return val;
};
      
//判断是否是对象
function isObject(obj){
    if(!obj){ return false; }
    let val = typeof obj === 'object' && isNaN(obj.length);
    return val;
};

// 新协议
function kkmhhybrid_share (opt={}, callback) {
    hybrid({
        hybridParam: {
            schema: "kkmhhybrid",
            tagname: "share",
        },
        param: {
            ...opt
        },
        on: true,
        callback: function (res) {
            if (callback && typeof callback === 'function') {
                callback(res);
            }
        }
    });
}

// 旧协议
function kkhybrid_share (opt={}, callback) {
    hybrid({
        hybridParam: {
            schema: "kkhybrid",
            tagname: "share",
        },
        param: {
            data: {
                action: opt.action,
                // 对话体传参
                SubType: opt.SubType,
                SubjectID: opt.SubjectID,
                ShareContentType: opt.ShareContentType,
                //标题
                title: opt.title,
                //描述
                desc: opt.desc,
                //icon地址
                imgUrl: opt.image,
                //链接地址
                link: opt.link
            }
        },
        on: true,
        callback: function (res) {
            if (callback && typeof callback === 'function') {
                callback(res);
            }
        }
    });
}


/**
 * 调起APP分享<br>
 * kkmhhybrid://share，wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=56591098}<br>
 * kkhybrid://share，wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=7112032}<br>
 * 备注:客户端版本大于5.60默认调用kkmhhybrid://share<br>
 * @param {Object} opt 参数对象
 * @param {String} opt.title 分享标题,必填参数  无默认值
 * @param {String} opt.desc  分享描述内容,必填参数 无默认值
 * @param {String} opt.link  分享链接,必填参数  无默认值
 * @param {String} opt.image 分享的图片,必填参数  无默认值
 * @param {String} opt.image_data 分享的base64图片,非必填参数  无默认值 kkmhhybrid://share生效
 * @param {Array} opt.platform 分享类型,非必填参数  默认:QQ,朋友圈,微博,空间,微信配置 kkmhhybrid://share生效
 * @param {Object} opt.action 分享执行动作,非必填参数  默认:立即拉起菜单栏配置 kkmhhybrid://share生效
 * @param {Object} opt.extraParams 分享执行动作,非必填参数  默认:{}  kkmhhybrid://share生效
 * @param {Boolean} opt.h5_tips 分享执行动作,非必填参数  默认:false   kkmhhybrid://share生效
 * @param {Function} opt.callback 回调函数
 * @param {Number} opt.criticalAppVersion 新旧协议兼容的判断版本（默认值在hybrid/index.js里配置），客户端版本小于该值使用旧协议，其余使用新协议
 * 
 * @returns 无返回值
 *  
 */
function share (opt={}) {
    let criticalAppVersion = opt.criticalAppVersion;
    let callback = opt.callback;
    delete opt.criticalAppVersion;
    delete opt.callback;
    
    // 数据校验 S
    let errStr=null; // parameter exception
    if(!opt.title){ 
        errStr='opt.title'
    }
    if(!opt.desc){ 
        errStr='opt.desc'
    }
    if(!opt.link){ 
        errStr='opt.link'
    }
    if(!opt.image){ 
        errStr='opt.image'
    }
    if(errStr){
        console.error(`${errStr} parameter exception`);
        return;
    }
    if(!opt.platform || !isArray(opt.platform) || opt.platform.length<=0){ 
        opt.platform = [
            {name : "QQ", type : 1, link:"", image:"",title:"",desc:""},
            {name : "WechatMoments", type : 1, link:"", image:"",title:"",desc:""},
            {name : "SinaWeibo", type : 2, link:"", image:"",title:"",desc:""},
            {name : "QZone", type : 2, link:"", image:""},
            {name : "Wechat", type : 1, link:"", image:""}
        ]
    }
    if(!opt.action || !isObject(opt.action) || JSON.stringify(opt.action)=="{}"){ 
        opt.action={
            type:1,
        }
    }
    if(!opt.extraParams || !isObject(opt.extraParams)){ 
        opt.extraParams = {}
    }
    if(typeof opt.h5_tips != 'boolean'){
        opt.h5_tips = false
    }
    // 数据校验 E

    const allow = window.kkBaseInfo.allowToKkmhhybrid(criticalAppVersion,560000);
    if(allow){
        // 调用新协议
        kkmhhybrid_share(opt, callback);
    }else{
        // 调用旧协议
        kkhybrid_share(opt, callback);
    }
}

export default share;


// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/share/index.js